import { State } from "../../types";

export const getSimulariumController = (state: State) =>
    state.simularium.simulariumController;
